/**
 * build a DOM id for a form control, so its label has something to point at
 */
export function fieldId(...parts: (string | number)[]): string {
  return parts.join('-').replace(/[^a-zA-Z0-9]+/g, '-')
}

export async function scrollErrorIntoView() {
  await wait(200)

  const el = document.querySelector('.v-form-error') as HTMLElement
  if (!el) {
    return
  }

  const field = el.closest('.field')
  field?.scrollIntoView({
    behavior: 'smooth',
  })

  field?.querySelector<HTMLElement>('input, select, textarea')?.focus({ preventScroll: true })
}

export function wait(ms: number) {
  return new Promise<void>((resolve) => setTimeout(resolve, ms))
}

export function takeAtLeast<T>(p: Promise<T>, ms: number) {
  return Promise.all([p, wait(ms)]).then(([result]) => result)
}
